<div id="hunt-details-page-wrapper">
  <div class="page-header">
    <div class="left">
      <hyperkit-breadcrumb-list class="breadcrumb-list" [items]="breadcrumbs()"></hyperkit-breadcrumb-list> 
      <hyperkit-typography variant="h2">{{ huntContext.state.name() }}</hyperkit-typography>
      <div class="meta-data-tags">
      <hyperkit-badge
      [variant]="huntContext.editor.priorityVariant()"
      [size]="'base'"
      [indicator]="'none'"
      [icon]="'check'"
      textLeft="Priority"
      [text]="huntContext.editor.priority()">
    </hyperkit-badge>
    <hyperkit-badge
    [variant]="huntContext.editor.statusVariant()"
    [size]="'base'"
    [indicator]="'none'"
    [icon]="'check'"
    textLeft="Status"
    [text]="huntContext.editor.status()">
  </hyperkit-badge>
  <hyperkit-badge
  *ngIf="huntContext.editor.outcome()"
  [variant]="huntContext.editor.outcomeVariant()"
  [size]="'base'"
  [indicator]="'none'"
  [icon]="'check'"
  textLeft="Outcome"
  [text]="huntContext.editor.outcome()">
</hyperkit-badge>
      <hyperkit-tag
        [mode]="'outline'"
        [closable]="false"
        [textLeft]="'Created'"
        [text]="huntContext.state.created()">
      </hyperkit-tag>

      <hyperkit-tag
      [mode]="'outline'"
      [closable]="false"
      [textLeft]="'Last Modified'"
      [text]="huntContext.state.lastModified()">
    </hyperkit-tag>
      
      <hyperkit-tag
        [mode]="'outline'"
        [closable]="false"
        [textLeft]="'Author'"
        [text]=" huntContext.state.assigneeFullName()">
      </hyperkit-tag>
      <hyperkit-tag
      [mode]="'outline'"
      [closable]="false"
      [textLeft]="'Author'"
      [text]=" huntContext.state.authorFullName()">
    </hyperkit-tag>
      <hyperkit-tag
      *ngIf="huntContext.query.hasHuntTemplate()"
      routerLink="/hunt/hunt-template/{{ huntContext.state.huntTemplateId()}}"
      icon="link-2"
      [mode]="'fill'"
      [closable]="false"
      [textLeft]="'Template'"
      [text]=" huntContext.state.huntTemplateName()">
    </hyperkit-tag>        
    </div>
    </div>
    <div class="right">
      <hyperkit-error *ngIf="error" [error]="error"></hyperkit-error>
      <hyperkit-button variant="standard" color="secondary" size="small" text="Continue to Reporting" (click)="closeHunt()" icon="arrow-right" iconPosition="right"></hyperkit-button>
      <hyperkit-button-menu variant="icon" color="secondary"  size="medium" icon="menu" (itemSelected)="handleMenuAction($event)" text="test" >
        <hyperkit-dropdown-menu-item value="update" (click)="editHunt()" label="Update Hunt Details"></hyperkit-dropdown-menu-item>
        <hyperkit-dropdown-menu-item value="archive" (click)="archiveHunt()" label="Archive"></hyperkit-dropdown-menu-item>
      </hyperkit-button-menu>
    </div>
  </div>
  <div class="page-content">
      <div id="hunt-packages">
        <div id="hunt-packages-header">
          <div id="hunt-package-title">
            <hyperkit-typography variant="h5">Packages ({{huntContext.query.huntPackages().length}})</hyperkit-typography>
          </div>
          <div id="hunt-package-list">
            <hunt-package-list-item
            *ngFor="let package of huntContext.query.huntPackages()"
            [huntPackage]="package"
            [routerLink]="[package.UUID]"
            [queryParamsHandling]="'preserve'">
          </hunt-package-list-item>
          </div>
        </div>
      </div>
      <div id="hunt-package-details">
        <hunt-details-editor 
          title="Abstract" 
          [value]="huntContext.editor.abstract()"
          (valueChange)="huntContext.editor.updateAbstract($event)"
        >
        </hunt-details-editor>
        <hunt-details-editor 
        title="Hypothesis" 
        [value]="huntContext.editor.hypothesis()"
        (valueChange)="huntContext.editor.updateHypothesis($event)"
        >
      </hunt-details-editor>
      </div>
      <div id="hunt-notes">
        <hunt-details-editor title="Notes"
        [value]="huntContext.editor.notes()"
        (valueChange)="huntContext.editor.updateNotes($event)">
      </hunt-details-editor>
      </div>
  </div>
</div>